import React from "react";

export default function BoxAufkleber(props) {
    return (
        <div className={"box " + props.customClass}>
            <div className="heading">
                <div className="nummerierung">
                        <p className="nummerierung nummerierung-p">{props.number}.</p>
                </div>
                <div className="headline">
                    <p className="headline-p">{props.title.toUpperCase()}</p>
                </div>
            </div>
            <div id={props.customClass} className="box-content-aufkleber">
                {props.children}
            </div>
        </div>
    );
}
